import { render } from "./modalProtocol.vue?vue&type=template&id=f645e382&ts=true"
import script from "./modalProtocol.vue?vue&type=script&lang=ts"
export * from "./modalProtocol.vue?vue&type=script&lang=ts"

import "./modalProtocol.vue?vue&type=style&index=0&id=f645e382&lang=less&rel=stylesheet%2Fless"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__